<p-toast position="top-right" key="notification" styleClass="notification-toast"></p-toast>
<p-toast position="top-right" key="portal"></p-toast>
<!-- Loading full-screen: logout em andamento OU verificação de acesso (waitlist HML) -->
<div class="app-loading-overlay" *ngIf="loggingOut || !approvalResolved">
    <div class="app-loading-spinner"></div>
    <span class="app-loading-text" *ngIf="loggingOut">{{ 'dashboard.sidebar.loggingOut' | transloco }}</span>
</div>

<div class="background">
    <p-menubar [model]="items" *ngIf="!accessBlocked && approvalResolved" [class.header-hidden]="headerHidden">
        <ng-template pTemplate="start">
            <a routerLink="{{ dashboardUrl }}" class="logo-link">
                <div class="logo-write"></div>
            </a>
        </ng-template>
        <ng-template pTemplate="item" let-item>
            <div class="nav-item-inner">
                <img *ngIf="item.icon === 'caravan-icon'" src="assets/img/ftvelopark/logovpcaravana.svg" class="caravan-menu-icon" alt="Caravan">
                <i *ngIf="item.icon && item.icon !== 'caravan-icon'" [class]="item.icon" class="nav-item-icon"></i>
                <span class="menu-item-label">{{ item.label }}</span>
                <span *ngIf="item.icon === 'caravan-icon'" class="live-indicator">
                    <span class="live-dot"></span>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="end">
            <!-- Páginas públicas do shell (ex.: /shared) abertas deslogado: sem notificações nem menu de usuário. -->
            <div class="header-actions" id="tour-header-actions" *ngIf="userId">
                <button class="notification-btn" (click)="openNotifications()" #notificationBtnRef>
                    <i class="pi pi-bell"></i>
                    <span class="notification-badge" *ngIf="notificationCount > 0">
                        {{ notificationCount > 9 ? '9+' : notificationCount }}
                    </span>
                </button>
                <p-button id="sidebarMenuBtn" icon="pi pi-bars" [rounded]="true" [text]="true" (click)="sidebarMenuVisible = true"
                    [style]="{'font-size': '1.2rem', 'color': 'white'}" />
                <button class="avatar-btn" (click)="sidebarProfileVisible = true">
                    <img *ngIf="socialAvatarUrl" [src]="socialAvatarUrl" class="header-avatar header-avatar--img" alt="Avatar" />
                    <span *ngIf="!socialAvatarUrl" class="header-avatar">{{ userInitials || 'U' }}</span>
                </button>
            </div>

            <div class="notification-dropdown" *ngIf="visibleNotifications" #notificacaoPainel>
                <div class="notification-dropdown-header">
                    <span class="notification-dropdown-title">{{ 'dashboard.notifications.title' | transloco }}</span>
                    <button class="notification-mark-all" (click)="markAllAsRead()" *ngIf="aggregatedNotifications.length > 0">
                        {{ 'dashboard.notifications.markAllRead' | transloco }}
                    </button>
                </div>
                <div class="notification-item"
                     *ngFor="let g of aggregatedNotifications"
                     [class.notification-unread]="!g.isRead"
                     (click)="onGroupedNotificationClick(g)">
                    <div class="notification-icon-wrapper" [ngClass]="getNotificationIconClass(g.type)">
                        <i [class]="getNotificationIcon(g.type)"></i>
                    </div>
                    <div class="notification-text">
                        <p class="notification-title">{{ g.title }}</p>
                        <p class="notification-body" *ngIf="g.message || g.body">{{ g.message || g.body }}</p>
                        <div class="notification-actors-preview" *ngIf="g.actors?.length">
                            <span class="notification-actor-chip" *ngFor="let a of g.actors">{{ a.nickname || a.userId }}</span>
                            <span class="notification-actor-more" *ngIf="g.totalActors > g.actors.length">
                                +{{ g.totalActors - g.actors.length }}
                            </span>
                        </div>
                        <small class="notification-date">{{ g.createdAt | date:'dd/MM/yyyy HH:mm' }}</small>
                    </div>
                </div>
                <button class="notification-load-more" *ngIf="hasMoreNotifications && aggregatedNotifications.length > 0" (click)="loadMoreNotifications()">
                    {{ 'dashboard.notifications.loadMore' | transloco }}
                </button>
                <p class="notification-empty" *ngIf="aggregatedNotifications.length === 0">{{ 'dashboard.notifications.empty' | transloco }}</p>
            </div>
        </ng-template>
    </p-menubar>
    <!-- Input único (escondido) p/ troca de foto — acionado ao clicar no avatar (via @ViewChild). -->
    <input #avatarFileInput type="file"
           accept=".jpg,.jpeg,.png,.webp,.gif,.avif,image/jpeg,image/png,image/webp,image/gif,image/avif"
           (change)="onAvatarSelected($event)" hidden />
    <!-- Ajuste de recorte (1:1, circular) antes de subir a nova foto. -->
    <app-avatar-cropper [(visible)]="avatarCropperVisible" [file]="avatarFileToCrop"
                        (cropped)="onAvatarCropped($event)"></app-avatar-cropper>
    <p-sidebar [(visible)]="sidebarMenuVisible" position="right" (onShow)="onSidebarShow()" (onHide)="lockBodyScroll(false)" styleClass="profile-sidebar-google">
        <!-- Header com avatar e info do usuário -->
        <div class="gprofile-header">
            <div class="gprofile-email-top">{{ userEmail }}</div>
            <div class="gprofile-avatar gprofile-avatar--editable"
                 [class.gprofile-avatar--uploading]="avatarUploading"
                 (click)="openAvatarPicker()"
                 [attr.title]="'socialFeed.changePhoto' | transloco">
                <img *ngIf="socialAvatarUrl" [src]="socialAvatarUrl" class="gprofile-avatar-img" alt="Avatar" />
                <span *ngIf="!socialAvatarUrl">{{ userInitials }}</span>
                <div class="gprofile-avatar__overlay">
                    <i class="pi" [ngClass]="avatarUploading ? 'pi-spin pi-spinner' : 'pi-camera'"></i>
                </div>
            </div>
            <div class="gprofile-greeting">{{ "dashboard.sidebar.hello" | transloco }}, {{ firstName || username }}!</div>
            <button class="gprofile-manage-btn" (click)="myProfile('data')">
                {{ "dashboard.sidebar.myAccount" | transloco }}
            </button>
        </div>

        <!-- Plan info card -->
        <div class="gprofile-plan-card">
            <div class="gprofile-plan-row">
                <div class="gprofile-plan-item">
                    <span class="gprofile-plan-label">{{ 'dashboard.plan.label' | transloco }}</span>
                    <span class="gprofile-plan-value">{{ planInfo?.name || 'Free' }}</span>
                </div>
                <div class="gprofile-plan-item">
                    <span class="gprofile-plan-label">{{ 'dashboard.plan.statusLabel' | transloco }}</span>
                    <span class="gprofile-plan-status"
                        [ngClass]="'gstatus-' + (planInfo?.status || 'none')">
                        {{ planInfo?.status === 'active' ? ('dashboard.plan.active' | transloco) :
                           planInfo?.status === 'inactive' ? ('dashboard.plan.inactive' | transloco) :
                           planInfo?.status === 'cancelled' ? ('dashboard.plan.cancelled' | transloco) :
                           planInfo?.status === 'pending_payment' ? ('dashboard.plan.pending' | transloco) :
                           planInfo?.status === 'expired' ? ('dashboard.plan.expired' | transloco) : ('dashboard.plan.noSubscription' | transloco) }}
                    </span>
                </div>
            </div>
            <div *ngIf="planInfo?.remainingDays != null && planInfo?.status === 'active'"
                 class="gprofile-remaining-days">
                <i class="pi pi-calendar"></i>
                {{ 'dashboard.plan.remainingDays' | transloco: { days: planInfo?.remainingDays } }}
            </div>
            <div *ngIf="planInfo?.status === 'pending_payment'" class="gprofile-plan-alert gplan-alert-warning">
                <i class="pi pi-exclamation-triangle"></i>
                {{ 'dashboard.plan.pendingPayment' | transloco }}
                <button class="gplan-alert-btn" (click)="showUpgradeModal = true">{{ 'dashboard.plan.viewPlans' | transloco }}</button>
            </div>
            <div *ngIf="planInfo?.status === 'cancelled' || planInfo?.status === 'inactive'" class="gprofile-plan-alert gplan-alert-danger">
                <i class="pi pi-times-circle"></i>
                {{ 'dashboard.plan.inactiveSubscription' | transloco }}
                <button class="gplan-alert-btn" (click)="showUpgradeModal = true">{{ 'dashboard.plan.viewPlans' | transloco }}</button>
            </div>
            <div class="gprofile-tokens-row" (click)="navigateToAiConsumption()">
                <i class="pi pi-bolt"></i>
                <div class="gprofile-tokens-info">
                    <span class="gprofile-tokens-count">{{ aiGaugePercent }}%</span>
                    <span class="gprofile-tokens-label">{{ (aiReserveMode ? 'dashboard.plan.aiReserveAvailable' : aiTankMode ? 'dashboard.plan.aiTankAvailable' : 'dashboard.plan.aiUsage') | transloco }}</span>
                </div>
                <div class="gprofile-tokens-bar">
                    <div class="gprofile-tokens-bar-fill" [style.width.%]="aiGaugePercent" [ngClass]="getAiBarClass()"></div>
                </div>
            </div>
            <!-- Compra avulsa só quando o tanque está acabando (<= 15% disponível) -->
            <button *ngIf="showBuyTokens"
                    class="gplan-manage-btn"
                    (click)="showBuyTokensModal = true">
                <i class="pi pi-shopping-cart"></i>
                {{ 'dashboard.plan.buyMoreBtn' | transloco }}
            </button>
            <!-- Leva para Minha Conta > Assinatura; o portal do Stripe abre de lá, em outra guia -->
            <button *ngIf="planInfo?.status === 'active'"
                    class="gplan-manage-btn"
                    (click)="myProfile('subscription')">
                <i class="pi pi-credit-card"></i>
                {{ 'dashboard.plan.manageBilling' | transloco }}
            </button>
        </div>

        <!-- Menu items -->
        <div class="gprofile-menu">
            <!-- Feed social desativado.
            <button class="gprofile-menu-item" (click)="pageFeed()">
                <i class="pi pi-users"></i>
                <span>{{ "dashboard.header.feed" | transloco }}</span>
            </button>
            -->
            <button class="gprofile-menu-item" (click)="pageGarage()">
                <i class="pi pi-warehouse"></i>
                <span>{{ "dashboard.header.garage" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="pageArquivos()">
                <i class="pi pi-folder-open"></i>
                <span>{{ "dashboard.header.files" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="pageftassistant()">
                <i class="ft-icon ft-icon-ftpilot"></i>
                <span>{{ 'dashboard.header.aiAssistant' | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="pageDownloads()">
                <i class="pi pi-download"></i>
                <span>{{ "downloads.menuItem" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="myProfile('trash')">
                <i class="pi pi-trash"></i>
                <span>{{ "dashboard.sidebar.trash" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="startTour()">
                <i class="pi pi-compass"></i>
                <span>{{ "welcomeTour.restart" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="managementAdmin()" *ngIf="this.adminUser">
                <i class="pi pi-wrench"></i>
                <span>{{ "adminPanel.title" | transloco }}</span>
            </button>
            <!--<button class="gprofile-menu-item" routerLink="/telemetry">
                <img src="assets/img/ftvelopark/logovpcaravana.svg" class="gprofile-caravan-icon" alt="Caravan">
                <span>{{ "caravan.header" | transloco }}</span>
            </button>-->
        </div>

        <!-- Logout -->
        <div class="gprofile-footer">
            <button class="gprofile-logout-btn" (click)="logout()">
                <i class="pi pi-sign-out"></i>
                {{ "dashboard.sidebar.exit" | transloco }}
            </button>
        </div>
    </p-sidebar>
    <p-sidebar [(visible)]="sidebarProfileVisible" position="right" (onShow)="onSidebarShow()" (onHide)="lockBodyScroll(false)" styleClass="profile-sidebar-google">
        <!-- Header com avatar e info do usuário -->
        <div class="gprofile-header">
            <div class="gprofile-email-top">{{ userEmail }}</div>
            <div class="gprofile-avatar gprofile-avatar--editable"
                 [class.gprofile-avatar--uploading]="avatarUploading"
                 (click)="openAvatarPicker()"
                 [attr.title]="'socialFeed.changePhoto' | transloco">
                <img *ngIf="socialAvatarUrl" [src]="socialAvatarUrl" class="gprofile-avatar-img" alt="Avatar" />
                <span *ngIf="!socialAvatarUrl">{{ userInitials }}</span>
                <div class="gprofile-avatar__overlay">
                    <i class="pi" [ngClass]="avatarUploading ? 'pi-spin pi-spinner' : 'pi-camera'"></i>
                </div>
            </div>
            <div class="gprofile-greeting">{{ "dashboard.sidebar.hello" | transloco }}, {{ firstName || username }}!</div>
            <button class="gprofile-manage-btn" (click)="myProfile('data')">
                {{ "dashboard.sidebar.myAccount" | transloco }}
            </button>
        </div>

        <!-- Plan info card -->
        <div class="gprofile-plan-card">
            <div class="gprofile-plan-row">
                <div class="gprofile-plan-item">
                    <span class="gprofile-plan-label">{{ 'dashboard.plan.label' | transloco }}</span>
                    <span class="gprofile-plan-value">{{ planInfo?.name || 'Free' }}</span>
                </div>
                <div class="gprofile-plan-item">
                    <span class="gprofile-plan-label">{{ 'dashboard.plan.statusLabel' | transloco }}</span>
                    <span class="gprofile-plan-status"
                        [ngClass]="'gstatus-' + (planInfo?.status || 'none')">
                        {{ planInfo?.status === 'active' ? ('dashboard.plan.active' | transloco) :
                           planInfo?.status === 'inactive' ? ('dashboard.plan.inactive' | transloco) :
                           planInfo?.status === 'cancelled' ? ('dashboard.plan.cancelled' | transloco) :
                           planInfo?.status === 'pending_payment' ? ('dashboard.plan.pending' | transloco) :
                           planInfo?.status === 'expired' ? ('dashboard.plan.expired' | transloco) : ('dashboard.plan.noSubscription' | transloco) }}
                    </span>
                </div>
            </div>
            <div *ngIf="planInfo?.remainingDays != null && planInfo?.status === 'active'"
                 class="gprofile-remaining-days">
                <i class="pi pi-calendar"></i>
                {{ 'dashboard.plan.remainingDays' | transloco: { days: planInfo?.remainingDays } }}
            </div>
            <div *ngIf="planInfo?.status === 'pending_payment'" class="gprofile-plan-alert gplan-alert-warning">
                <i class="pi pi-exclamation-triangle"></i>
                {{ 'dashboard.plan.pendingPayment' | transloco }}
                <button class="gplan-alert-btn" (click)="showUpgradeModal = true">{{ 'dashboard.plan.viewPlans' | transloco }}</button>
            </div>
            <div *ngIf="planInfo?.status === 'cancelled' || planInfo?.status === 'inactive'" class="gprofile-plan-alert gplan-alert-danger">
                <i class="pi pi-times-circle"></i>
                {{ 'dashboard.plan.inactiveSubscription' | transloco }}
                <button class="gplan-alert-btn" (click)="showUpgradeModal = true">{{ 'dashboard.plan.viewPlans' | transloco }}</button>
            </div>
            <div class="gprofile-tokens-row" (click)="navigateToAiConsumption()">
                <i class="pi pi-bolt"></i>
                <div class="gprofile-tokens-info">
                    <span class="gprofile-tokens-count">{{ aiGaugePercent }}%</span>
                    <span class="gprofile-tokens-label">{{ (aiReserveMode ? 'dashboard.plan.aiReserveAvailable' : aiTankMode ? 'dashboard.plan.aiTankAvailable' : 'dashboard.plan.aiUsage') | transloco }}</span>
                </div>
                <div class="gprofile-tokens-bar">
                    <div class="gprofile-tokens-bar-fill" [style.width.%]="aiGaugePercent" [ngClass]="getAiBarClass()"></div>
                </div>
            </div>
            <!-- Compra avulsa só quando o tanque está acabando (<= 15% disponível) -->
            <button *ngIf="showBuyTokens"
                    class="gplan-manage-btn"
                    (click)="showBuyTokensModal = true">
                <i class="pi pi-shopping-cart"></i>
                {{ 'dashboard.plan.buyMoreBtn' | transloco }}
            </button>
            <!-- Leva para Minha Conta > Assinatura; o portal do Stripe abre de lá, em outra guia -->
            <button *ngIf="planInfo?.status === 'active'"
                    class="gplan-manage-btn"
                    (click)="myProfile('subscription')">
                <i class="pi pi-credit-card"></i>
                {{ 'dashboard.plan.manageBilling' | transloco }}
            </button>
        </div>

        <!-- Menu items -->
        <div class="gprofile-menu">
            <button class="gprofile-menu-item" (click)="myProfile('trash')">
                <i class="pi pi-trash"></i>
                <span>{{ "dashboard.sidebar.trash" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="startTour()">
                <i class="pi pi-compass"></i>
                <span>{{ "welcomeTour.restart" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="pageArquivos()">
                <i class="pi pi-folder-open"></i>
                <span>{{ "dashboard.header.files" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="pageDownloads()">
                <i class="pi pi-download"></i>
                <span>{{ "downloads.menuItem" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="pageMyTuner()">
                <i class="pi pi-link"></i>
                <span>{{ "tuner.myTuner.menuItem" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" *ngIf="accountType === 'tuner'" (click)="pageTunerDashboard()">
                <i class="pi pi-star-fill"></i>
                <span>{{ "tuner.panel.menuItem" | transloco }}</span>
            </button>
            <button class="gprofile-menu-item" (click)="managementAdmin()" *ngIf="this.adminUser">
                <i class="pi pi-wrench"></i>
                <span>{{ "adminPanel.title" | transloco }}</span>
            </button>
            <!--<button class="gprofile-menu-item" routerLink="/telemetry">
                <img src="assets/img/ftvelopark/logovpcaravana.svg" class="gprofile-caravan-icon" alt="Caravan">
                <span>{{ "caravan.header" | transloco }}</span>
            </button>-->
        </div>

        <!-- Logout -->
        <div class="gprofile-footer">
            <button class="gprofile-logout-btn" (click)="logout()">
                <i class="pi pi-sign-out"></i>
                {{ "dashboard.sidebar.exit" | transloco }}
            </button>
        </div>
    </p-sidebar>
    <app-pro-feature-modal
        [(visible)]="showUpgradeModal"
        [currentPlanId]="planInfo?.planId ?? null"
        [currentPlanExpired]="planInfo?.status === 'expired'"
        [billingType]="planInfo?.billingType ?? null"
        (planUpgraded)="onPlanUpgraded()" />
    <app-token-purchase-modal
        [(visible)]="showBuyTokensModal"
        [currentCreditsTotal]="aiCreditsTotal" />
    <!-- Senha de mapa/log protegido — dirigido pelo MapPasswordService (FileMapService.read). -->
    <app-map-password-modal />



    <!-- Detalhe da notificação "conteúdo removido" -->
    <p-dialog
        [(visible)]="contentRemovedModalVisible"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true"
        [header]="'dashboard.notifications.contentRemoved.title' | transloco"
        styleClass="content-removed-dialog"
        [style]="{ width: 'min(460px, 92vw)' }"
    >
        <div class="content-removed-body" *ngIf="contentRemovedInfo as info">
            <p class="content-removed-intro">
                {{ (info['targetType'] === 'Comment'
                      ? 'dashboard.notifications.contentRemoved.introComment'
                      : 'dashboard.notifications.contentRemoved.introPost') | transloco }}
            </p>
            <img *ngIf="contentRemovedMediaSrc" class="content-removed-media" [src]="contentRemovedMediaSrc" alt="" />
            <blockquote class="content-removed-excerpt" *ngIf="info['excerpt']">"{{ info['excerpt'] }}"</blockquote>
            <p class="content-removed-reason" *ngIf="info['reason']">
                <strong>{{ 'dashboard.notifications.contentRemoved.reasonLabel' | transloco }}</strong> {{ info['reason'] }}
            </p>
            <p class="content-removed-notes" *ngIf="info['notes']">{{ info['notes'] }}</p>
        </div>
        <ng-template pTemplate="footer">
            <button type="button" class="content-removed-close" (click)="contentRemovedModalVisible = false">
                {{ 'dashboard.notifications.contentRemoved.close' | transloco }}
            </button>
        </ng-template>
    </p-dialog>

    <!-- Waitlist HML: aprovação pendente -->
    <div class="access-blocked-screen" *ngIf="accessBlocked">
        <div class="access-blocked-card">
            <div class="access-blocked-logo"></div>
            <i class="pi pi-lock access-blocked-icon"></i>
            <h2 class="access-blocked-title">{{ 'accessBlocked.title' | transloco }}</h2>
            <p class="access-blocked-text">{{ 'accessBlocked.message' | transloco }}</p>
            <button class="access-blocked-logout" (click)="logout()">
                <i class="pi pi-sign-out"></i>
                {{ 'accessBlocked.logout' | transloco }}
            </button>
        </div>
    </div>

    <!-- Aviso (não bloqueio) de uso simultâneo da conta, detectado no login -->
    <p-dialog
        id="modal-accountSharingAlert"
        [(visible)]="accountSharingAlertVisible"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true"
        [header]="'accountSharingAlert.title' | transloco"
        styleClass="account-sharing-dialog"
        [style]="{ width: 'min(460px, 92vw)' }"
    >
        <p class="account-sharing-text">
            {{ (accountSharingCountry
                    ? 'accountSharingAlert.messageWithCountry'
                    : 'accountSharingAlert.message') | transloco: { country: accountSharingCountry } }}
        </p>
        <ng-template pTemplate="footer">
            <button type="button" class="account-sharing-dismiss" (click)="dismissAccountSharingAlert()">
                {{ 'accountSharingAlert.dismiss' | transloco }}
            </button>
            <button type="button" class="account-sharing-confirm" (click)="goToChangePassword()">
                {{ 'accountSharingAlert.changePassword' | transloco }}
            </button>
        </ng-template>
    </p-dialog>

    <div class="container" *ngIf="!accessBlocked && approvalResolved">
        <div class="header-wrapper">
            <div class="header-image" [ngStyle]="{'background-image': footerBackground}"></div>
            <p-breadcrumb class="header-breadcrumb" [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
        </div>
        <div class="subcontainer">
            <router-outlet></router-outlet>
        </div>
    </div>

        
    <footer class="footer-modern">
      <div class="footer-inner">
        <div class="footer-brand">
          <img src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot" class="footer-logo-img" />
        </div>
        <div class="footer-divider"></div>
        <p class="footer-copy">{{ 'footer.rightsReserved' | transloco }}</p>
      </div>
    </footer>

</div>